import React from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import {
    FilterComponentWrapper,
    FilterComponentHeaderFooter,
    TextBold,
    LineSeparator,
} from './FilterView.styled';
import CommonRadioCheckboxFilter from 'src/common/refactoredComponents/filter/CommonRadioCheckboxFilter';
import FilterAccountLabel from 'src/common/components/filter/FilterAccountLabel';
import { Dot } from 'src/styles/CommonStyles.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const FilterView = ({
    header,
    defaultViewFilter,
    selectedViewFilter,
    setSelectedViewFilter,
    isExpanded,
    updateExpandedViews,
    viewFiltersLists,
    viewFilterName,
    showDefault, //Boolean Used to Show Default Label in Calendar Page
    setDefaultAction, //Boolean Used to  Show Default Button in Calendar Page
    isAccountView,
    width,
    whiteSpace,
    marginBottom,
    overFlow,
    textOverflow,
    showDot, //Show Dot in View Header
    isFilterDisable, //Boolean to make disable when filter list is empty

    setDefaultCalendarView = () => {},
    showFavourite = false,
}) => {
    const { t } = useTranslation();
    const checkIfDefault = (filterId) => {
        if (filterId === defaultViewFilter.id) {
            return true;
        } else {
            return false;
        }
    };
    const hasDefaultViewChanged = () => {
        if (
            !selectedViewFilter.id ||
            selectedViewFilter.id === defaultViewFilter.id
        ) {
            return false;
        } else {
            return true;
        }
    }; 
    return (
        <FilterComponentWrapper
            className={
                isFilterDisable
                    ? viewFiltersLists?.filter(
                          (item) =>
                              item.name !== 'All' &&
                              item.name !== 'All Districts' &&
                              item.name !== 'All Territories'
                      ).length > 0
                        ? ''
                        : 'disabled'
                    : ''
            }
            marginBottom={marginBottom}
        >
            <FilterComponentHeaderFooter
                onClick={() => {
                    updateExpandedViews({
                        view: viewFilterName,
                        value: !isExpanded,
                    });
                }}
            >
                <TextBold color={'#140F4B'}>{header}</TextBold>
                <div>
                    {(() => {
                        if (isExpanded) {
                            return (
                                <>
                                    <img
                                        src={DownArrowFilter}
                                        style={{ transform: 'rotate(180deg)' }}
                                    ></img>
                                </>
                            );
                        } else {
                            return (
                                <>
                                    {showDot ? <Dot /> : ''}
                                    <img src={DownArrowFilter}></img>
                                </>
                            );
                        }
                    })()}
                    {/* <img
                        src={isExpanded ? UpArrowFilter : DownArrowFilter}
                    ></img> */}
                </div>
            </FilterComponentHeaderFooter>
            {(() => {
                if (isExpanded) {
                    return (
                        <>
                            {viewFiltersLists.length !== 0 && <LineSeparator />}
                            {viewFiltersLists.map((viewFiltersList) => {
                                return (
                                    <React.Fragment key={viewFiltersList.id}>
                                        <CommonRadioCheckboxFilter
                                            isRadio={true}
                                            key={viewFiltersList.id}
                                            filterItemRadio={viewFiltersList}
                                            setSelectedCalendarView={
                                                setSelectedViewFilter
                                            }
                                            isChecked={
                                                selectedViewFilter?.id
                                                    ? selectedViewFilter?.id ===
                                                      viewFiltersList?.id
                                                    : viewFiltersList?.selected
                                            }
                                            radioName={viewFilterName}
                                            width={width}
                                            whiteSpace={whiteSpace}
                                            overFlow={overFlow}
                                            textOverflow={textOverflow}
                                            isDefault={
                                                showDefault
                                                    ? checkIfDefault(
                                                          viewFiltersList.id
                                                      )
                                                    : false
                                            }
                                        >
                                            {isAccountView && (
                                                <FilterAccountLabel
                                                    name={viewFiltersList.name}
                                                    accountId={
                                                        viewFiltersList.accountId
                                                    }
                                                    showFavourite={
                                                        showFavourite
                                                    }
                                                    isFavourite={
                                                        viewFiltersList?.isFavorite
                                                    }
                                                />
                                            )}
                                        </CommonRadioCheckboxFilter>
                                    </React.Fragment>
                                );
                            })}
                            {setDefaultAction ? (
                                <FilterComponentHeaderFooter>
                                    <Button
                                    id={'set-default-calendar-view-button'}
                                        show={true}
                                        width={'100%'}
                                        height={'38px'}
                                        clicked={() => {
                                            setDefaultCalendarView(
                                                selectedViewFilter
                                            );
                                        }}
                                        // primary={hasDefaultViewChanged()}
                                        disabled={!hasDefaultViewChanged()}
                                        variant={hasDefaultViewChanged() ? ButtonStyles?.primary : ButtonStyles?.disabled}
                                    >
                                        <TextBold color={'#FFFF'}>
                                            {t('filter.setDefaultButton')}
                                        </TextBold>
                                    </Button>
                                </FilterComponentHeaderFooter>
                            ) : null}
                        </>
                    );
                } else {
                    return <></>;
                }
            })()}
        </FilterComponentWrapper>
    );
};

export default FilterView;
